import { ChatBot } from "../components/chatBot";

export const ChatBotView = () => {
  return (
    <>
      <ChatBot />
    </>
  );
};
